import {
  ConfirmDialogActions,
  ConfirmDialogIdentifier,
} from 'legacy/lut/components/shared/Confirm/actions'

export type ConfirmDialogState = Partial<Record<ConfirmDialogIdentifier, boolean>>

export const initialState = {}

export function confirmDialogReducer(
  state: ConfirmDialogState,
  action: ConfirmDialogActions
): ConfirmDialogState {
  switch (action.type) {
    case 'SHOW_CONFIRM': {
      const id = action.payload
      return {
        ...state,
        [id]: true,
      }
    }

    case 'REGISTER_CONFIRM':
    case 'HIDE_CONFIRM': {
      const id = action.payload
      return {
        ...state,
        [id]: false,
      }
    }

    case 'UNREGISTER_CONFIRM': {
      const id = action.payload

      // eslint-disable-next-line
      const { [id]: unregisteredDialog, ...restDialogs } = state

      return restDialogs
    }

    default:
      return initialState
  }
}
